export function playAudio(file, volume = 10) {
  var mp3 = new Audio(file);
  mp3.volume = volume / 100;
  mp3.play().catch((e) => {
    // 如果用户没有交互页面会导致play失败，不需要处理
    console.error(e);
  });
}
export function isVideoByExtension(ext) {
  return ["mp4", "webm", "ogv"].includes(ext.toLowerCase());
}
export function isAudioByExtension(ext) {
  return ["mp3", "wav", "ogg", "opus", "m4a"].includes(ext.toLowerCase());
}
export function getVideoBlobMetadata(fileUrl) {
  let videoElement = document.createElement("video");
  videoElement.src = fileUrl;
  videoElement.autoplay = true;
  videoElement.muted = true;
  return new Promise((resolve) => {
    videoElement.addEventListener("canplay", function () {
      let canvas = document.createElement("canvas");
      canvas.width = videoElement.videoWidth; //画板宽
      canvas.height = videoElement.videoHeight; //画板的高
      //通过画板的drawImage属性对图片进行处理
      canvas
        .getContext("2d")
        .drawImage(videoElement, 0, 0, canvas.width, canvas.height);
      //处理完毕通过toDataURL属性转为图片格式拿去base64图片路径
      canvas.toBlob((blob) => {
        resolve({
          posterBase64: canvas.toDataURL(),
          posterFile: new File([blob], "poster", { type: "image/png" }),
          width: videoElement.videoWidth,
          height: videoElement.videoHeight,
          duration: videoElement.duration.toFixed(2),
        });
      }, "image/png");
    });
  });
}
export function getAudioBlobMetadata(fileUrl) {
  let audio = new Audio(fileUrl);
  return new Promise((resolve) => {
    audio.addEventListener("loadedmetadata", () => {
      let duration = audio.duration.toFixed(2);
      resolve({
        duration,
      });
    });
  });
}

/**
 * 获取视频的宽高
 * @param {File} file 视频文件
 * @returns {Promise<{file: File, width: number, height: number}>} 视频的宽高
 */
export async function getVideoDimension(file) {
  return new Promise((resolve, reject) => {
    let url = window.URL || window.webkitURL || window.mozURL || window.msURL;
    const video = document.createElement('video');
    let videoUrl = url.createObjectURL(file);

    video.onloadedmetadata = function () {
      url.revokeObjectURL(videoUrl); // 释放内存
      resolve({
        file,
        width: this.videoWidth,
        height: this.videoHeight,
      });
    };

    video.onerror = function () {
      url.revokeObjectURL(videoUrl);
      reject(new Error('无法加载视频'));
    };

    video.src = videoUrl;
  });
}

/**
 * 获取视频的宽高
 * @param {Array<File>} files 视频文件
 * @returns {Promise<Array<{file: File, width: number|null, height: number|null}>>} 视频的宽高
 */
export async function getVideoWidthHeight(files) {
  if (!Array.isArray(files)) {
    return [
      {
        file: files,
        width: null,
        height: null,
      },
    ];
  }

  const res = await Promise.all(files.map((file) => getVideoDimension(file)));

  return res;
}
